import moment from "moment-timezone";

export function isValidDate(date) {
  if (date === null || date === undefined || typeof date !== "string") {
    return false;
  }
  // Remove any leading/trailing whitespace
  date = date.trim();
  // Check if the input is a number
  if (!isNaN(parseFloat(date)) && isFinite(date)) {
    return false;
  }
  // Define regex patterns for common date formats, including ISO 8601
  const datePatterns = [
    /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
    /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
    /^\d{2}-\d{2}-\d{4}$/, // DD-MM-YYYY
    /^\d{4}\/\d{2}\/\d{2}$/, // YYYY/MM/DD
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/, // YYYY-MM-DDTHH:MM:SS
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/,
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{2}$/,
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/,
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{6}$/,
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{5}$/,
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{4}$/,
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{1}$/,
  ];
  // Check if the date matches any of the patterns
  const isMatch = datePatterns.some((pattern) => pattern.test(date));
  if (!isMatch) {
    return false;
  }
  // Parse the date string
  const timestamp = Date.parse(date);
  return !isNaN(timestamp);
}

export const handleDateFormat = (date) => {
  //const timestamp = new Date(date);
  const formattedDate = moment
    .utc(date)
    .tz("Asia/Kolkata")
    .format("DD/MM/YYYY HH:mm:ss");
  return formattedDate;
};

export const checkSourceMedium = (medium) => {
  const sourceList = [
    "Affiliat",
    "Affiliate_Referral",
    "affiliates",
    "Affiliates",
    "Affiliates,Affiliates",
    "Affiliates,Affiliates,Affiliates",
    "Quality_Affilia",
    "quality_affiliates",
    "Quality_Affiliates",
    "Quality_Affiliates,Quality_Affiliates",
    "Quality_Affiliates,Quality_Affiliates,Quality_Affiliates,Quality_Affiliates",
    "Telagram_BAU",
    "telegram_bau",
    "Telegram_BAU",
    "Telegram_BAU,Telegram_BAU",
    "youtube_bau",
    "Youtube_BAU",
    "YouTube_BAU",
    "Youtube_BAU,Aff",
    "Youtube_BAU,GloNova",
    "Youtube_BAU,social",
    "Youtube_BAU,Youtube_BAU",
    "Telegram",
  ];

  if (sourceList.includes(medium)) {
    return true;
  }
  return false;
};

export function maskLeadDetails(value) {
  // null, undefined, or empty string
  if (!value || value.trim() === "") {
    return "-";
  }

  // Check if it's a phone number (10 digits)
  if (/^\d{10}$/.test(value)) {
    return value.replace(/\d/g, "X");
  }

  // Check if it's an email
  if (/^[^@]+@[^@]+\.[^@]+$/.test(value)) {
    const [localPart, domain] = value.split("@");
    return "X".repeat(localPart.length) + "@" + domain;
  }

  // Check if it's a PAN (10 characters)
  if (/^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(value)) {
    return value.replace(/./g, "X");
  }

  // return specific error based on fieldname
  if (value.includes("@")) {
    return "Invalid email format";
  } else if (/^\d+$/.test(value) && value.length !== 10) {
    return "Invalid number format";
  } else if (/^[a-z0-9]{10}$/i.test(value)) {
    return "Invalid PAN format";
  }

  return "Invalid format";
}

export const sensitiveFields = [
  "Phone Number",
  "Mobile Number",
  "Email",
  "Pan Number",
  "Referee Mobile",
];

export const sensitiveSchemaFields = ["phone","emailaddress", "mx_pan_number", "mobile", "mx_referee_mobile"]